import * as actionTypes from "./actionTypes";

export const disputeAuthorizationFile = (disputeAuthorizationForm) => {
  return {
    type: actionTypes.DISPUTE_AUTHORIZATION_FILE,
    disputeAuthorizationForm: disputeAuthorizationForm,
  };
};
export const resetDisputeAuthorizationFile = () => {
  return {
    type: actionTypes.RESET_DISPUTE_AUTHORIZATION_FILE,
  };
};
